import { Photo } from '@/components/shared/misc'
import { ProfilePlaceholder } from '@/components/shared/misc/ProfilePlaceholder'
import clsx from 'clsx'
import { FC } from 'react'
interface Props {
  initials: string
  photo?: string
  width?: string //expects a tailwind class
  height?: string //expects a tailwind class
  bg?: string
  avatarSize?: 'small' | 'medium' | 'large'
  roundedSize?: string
}

export const Avatar: FC<Props> = ({
  initials,
  photo,
  width,
  height,
  bg,
  avatarSize,
  roundedSize = 'rounded-full'
}) => {
  const widthClass = width ?? 'w-12'
  const heightClass = height ?? 'h-12'
  return (
    <div className={clsx(widthClass, heightClass)}>
      {photo && photo.length > 0 ? (
        <Photo
          url={photo}
          title={initials}
          className={clsx(`${roundedSize} w-full h-full bg-white object-cover`)}
        />
      ) : (
        <ProfilePlaceholder
          bg={bg || 'bg-[#3461ff]'}
          text={initials}
          width={width}
          height={height}
          size={avatarSize}
          roundedSize={roundedSize}
        />
      )}
    </div>
  )
}
